const fragmentCategory = `
  fragment CategoryFields on CategoryTree {
    id  
    is_anchor
    name
    position
    product_count
    uid
    url_path
    url_suffix
    image
    include_in_menu
    anchor_to_menu
    description
  }
`;

export default `
  query categoryList {
    categories {
      items {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
            children {
              ...CategoryFields
            }
          }
        }
      }
    }
  }
  ${fragmentCategory}
`;
